export default __webpack_public_path__ + "static/media/wrslogo.a673650c.png";